import { runNavigatorShare } from '../../../services/MarppleShop/shared/client/navigator';
import { MShopUtilF } from '@modules/MShop/Util/F/Function/module/MShopUtilF';

export const clipboard = async (url: string, is_mobile?: boolean): Promise<void> => {
  const copyToClipboard = () => {
    if (navigator.clipboard) navigator.clipboard.writeText(url);
    else MShopUtilF.clipboard(url);
  };

  if (MShopUtilF.isApp())
    return MShopUtilF.postMessage({
      share: {
        url,
      },
    });

  if (is_mobile)
    return runNavigatorShare({
      url,
    }).catch(copyToClipboard);

  return copyToClipboard();
};
